import React from "react";
import { useNavigate } from "react-router-dom";
import logger from "../../utils/logger";

const TestMpinSetup: React.FC = () => {
  const navigate = useNavigate();

  const testMpinSetupFlow = () => {
    // Set test phone number and flag
    localStorage.setItem("phone", "9876543210");
    localStorage.setItem("countryCode", "91");
    localStorage.setItem("showMpinSetup", "true");
    localStorage.setItem("mpinSetupType", "reset");
    
    logger.log("Test: Set showMpinSetup flag (RESET) and navigating to OTP verify");
    navigate("/otp-verify");
  };

  const checkFlag = () => {
    const flag = localStorage.getItem("showMpinSetup");
    const type = localStorage.getItem("mpinSetupType");
    logger.log("showMpinSetup flag:", flag);
    logger.log("mpinSetupType flag:", type);
    alert(`showMpinSetup: ${flag}\nmpinSetupType: ${type}`);
  };

  const clearFlag = () => {
    localStorage.removeItem("showMpinSetup");
    localStorage.removeItem("mpinSetupType");
    logger.log("Cleared both MPIN flags");
  };

  return (
    <div style={{ padding: "20px" }}>
      <h3>MPIN Test Controls</h3>
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <button onClick={testMpinSetupFlow} style={{ padding: "10px", backgroundColor: "#3A4B86", color: "white" }}>
          Test MPIN Setup Flow
        </button>
        <button onClick={checkFlag} style={{ padding: "10px" }}>
          Check Flag
        </button>
        <button onClick={clearFlag} style={{ padding: "10px" }}>
          Clear Flag
        </button>
      </div>
      <p>1. Click "Test MPIN Setup Flow" to set flag and go to OTP verification</p>
      <p>2. In OTP page, enter any 4 digits to see if MPIN setup shows</p>
      <p>3. Use "Check Flag" to see current flag value</p>
    </div>
  );
};

export default TestMpinSetup;